export default{
  // 读取token
  get UserToken(){
    return localStorage.getItem('token')
  },
  // 设置token
  set UserToken(value){
    localStorage.setItem('token',value)
  },
  // 读取头像
  get UserIMAGES(){
    return localStorage.getItem('image')
  },
  // 设置头像
  set UserIMAGES(value){
    localStorage.setItem('image',value)
  },
   // 读取名字
  get UserName(){
    return localStorage.getItem('name')
  },
  // 设置名字
  set UserName(value){
    localStorage.setItem('name',value)
  },
  
}